import React, { PureComponent } from 'react';

class PopularityDropdown extends PureComponent {

  constructor(){
    super();
    this.state = {
      dropdownSelected:false
    };
    this.documentClickHandler = this.documentClickHandler.bind(this);
    //this.onDropDownItemClick = this.onDropDownItemClick.bind(this);
  }

  componentDidMount(){
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){
   try{
    if(e.target.offsetParent.className !== "filterDropdown"){
        if(this.state.dropdownSelected) this.setState({dropdownSelected: false});
    }
    }catch(e){}
  }

  onDropDownClick(e){
    e.preventDefault();
    this.setState({dropdownSelected: !this.state.dropdownSelected });
  }

  onDropDownItemClick(e, activeItem){
    e.preventDefault();
    this.setState({dropdownSelected:false});
    this.props.onDropDown(activeItem);
  }

  render(){
    return (
      <div className={`filterDropdown trips ${this.props.popularityType}`}>
        <div className="row">
          <div className="columns small-12">

            <a className="filterDropdown-btn" onClick={e => this.onDropDownClick(e) } >
              {this.props.activeDropDown}
              <i className={`fa fa-chevron-down ${this.state.dropdownSelected ? 'active' : ''}`} aria-hidden="true"></i>
            </a>
          </div>
          <div className="columns small-12">
            <ul style={{display: this.state.dropdownSelected ? 'block':'none' }}>
              <li onClick={e => this.onDropDownItemClick(e, 'Popularity') } >Popularity</li>
              <li onClick={e => this.onDropDownItemClick(e, 'Lowest price') } >Lowest price</li>
              <li onClick={e => this.onDropDownItemClick(e, 'Highest price') } >Highest price</li>
              <li onClick={e => this.onDropDownItemClick(e, 'Longest duration') } >Longest duration</li>
              <li onClick={e => this.onDropDownItemClick(e, 'Shortest duration') } >Shortest duration</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

}

export default PopularityDropdown;



// WEBPACK FOOTER //
// ./src/components/search/components/filters/popularityDropdown.js